import React from 'react'

import withApiService from '../../hoc/with-api-service'
import withData from '../../hoc/with-data'

import DroppedMenuList from './dropped-menu-list'

const DroppedMenu = ({response, visible, setVisible, categoryId}) => {
  const {data} = response;
  const classNameVisible = data && visible ? '_visible' : undefined;

  const handleClick = event => {
    if (event.target.tagName.toLowerCase() !== 'a') {
      return
    }

    setVisible(false)
  };

  return (
    <div className={`dropped-menu dropped-menu${classNameVisible}`}>
      <div className="wrapper"
           onClick={handleClick}>
        <DroppedMenuList title="Повод"
                         list={data && data.reason}
                         filterName="reasonFilter"
                         category={categoryId}/>
        <DroppedMenuList title="Категории"
                         list={data && data.type}
                         filterName="typeFilter"
                         category={categoryId}/>
        <DroppedMenuList title="Сезон"
                         list={data && data.season}
                         filterName="seasonFilter"
                         category={categoryId}/>
        <DroppedMenuList title="Бренд"
                         list={data && data.brand}
                         filterName="brandFilter"
                         category={categoryId}/>
      </div>
    </div>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getFilters
  };
};

export default withApiService(mapMethodsToProps)(withData(DroppedMenu))
